import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=10af7ddd&scoped=true&"
import script from "./classify.vue?vue&type=script&lang=js&"
export * from "./classify.vue?vue&type=script&lang=js&"
import style0 from "./classify.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./classify.vue?vue&type=style&index=1&id=10af7ddd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af7ddd",
  null
  
)

export default component.exports